var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlacktw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1236 1.98809C20.3369 2.32994 19.5045 2.55515 18.6527 2.65661C19.5478 2.13245 20.221 1.29972 20.546 0.314605C19.6997 0.809482 18.7753 1.15671 17.8125 1.34142C17.407 0.916506 16.9194 0.578477 16.3793 0.347876C15.8391 0.117276 15.2577 -0.00107808 14.6704 7.39936e-06C12.2926 7.39936e-06 10.3683 1.89633 10.3683 4.23397C10.3666 4.55913 10.4039 4.88332 10.4793 5.19962C8.77418 5.11968 7.10455 4.68472 5.5772 3.92255C4.04985 3.16038 2.69841 2.08779 1.60934 0.773394C1.22727 1.4175 1.02521 2.1524 1.02427 2.9013C1.02427 4.36943 1.79023 5.66714 2.94682 6.42742C2.26158 6.41116 1.59037 6.22979 0.990193 5.89872V5.95116C0.990193 8.00478 2.4758 9.71323 4.44203 10.1021C4.07229 10.2007 3.69127 10.2506 3.30861 10.2507C3.03708 10.2511 2.76617 10.2248 2.49983 10.172C3.04644 11.8542 4.63735 13.0777 6.52188 13.1126C4.99056 14.2928 3.11051 14.9306 1.1772 14.9259C0.834038 14.9254 0.49119 14.905 0.150391 14.8648C2.11714 16.1206 4.40334 16.7849 6.73685 16.7786C14.6612 16.7786 18.9905 10.3249 18.9905 4.72772C18.9905 4.5442 18.9856 4.36069 18.9769 4.18154C19.8172 3.58383 20.5441 2.84105 21.1236 1.98809Z",
    fill: "#1F2732"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacktw);
export default __webpack_public_path__ + "static/media/blacktw.f8ab5b8d24ce381e557815e65f5ab600.svg";
export { ForwardRef as ReactComponent };